"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var TextFieldPassword =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextFieldPassword, _React$Component);

  function TextFieldPassword() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextFieldPassword);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextFieldPassword)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      showPassword: false
    };

    _this.handleMouseDownPassword = function (event) {
      event.preventDefault();
    };

    _this.handleClickShowPassword = function () {
      _this.setState(function (state) {
        return {
          showPassword: !state.showPassword
        };
      });
    };

    return _this;
  }

  _createClass(TextFieldPassword, [{
    key: "render",
    value: function render() {
      var showPassword = this.state.showPassword;
      return _react.default.createElement(_TextField.default, Object.assign({
        type: showPassword ? 'text' : 'password',
        endAdornment: _react.default.createElement(_core.InputAdornment, {
          position: "end"
        }, _react.default.createElement(_core.IconButton, {
          "aria-label": "Toggle password visibility",
          onClick: this.handleClickShowPassword,
          onMouseDown: this.handleMouseDownPassword
        }, _react.default.createElement(_Icon.default, {
          name: showPassword ? 'visibility_off' : 'visibility'
        })))
      }, this.props));
    }
  }]);

  return TextFieldPassword;
}(_react.default.Component);

var _default = TextFieldPassword;
exports.default = _default;